(() => {
  if (window.hxNavigationLoaded) return;
  window.hxNavigationLoaded = true;
  const transitions = new WeakMap();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 1200px)');
  const parts = (detail) => ({ summary: detail.querySelector(':scope > summary'), panel: detail.querySelector(':scope > [data-hx-panel]') });
  const setOpen = (detail, opening) => {
    const { summary, panel } = parts(detail);
    if (!summary || !panel || (!detail.open && !opening)) return;
    const previous = transitions.get(detail);
    const start = previous ? { opacity: getComputedStyle(panel).opacity, transform: getComputedStyle(panel).transform } : { opacity: opening ? 0 : 1, transform: opening ? 'translateY(-7px)' : 'translateY(0)' };
    previous?.animation.cancel();
    detail.open = true;
    if (desktop.matches && panel.classList.contains('hx-nav-panel--cinematic')) {
      const width = Math.min(1060, innerWidth - 80);
      panel.style.setProperty('--hx-menu-left', `${(innerWidth - width) / 2 - detail.getBoundingClientRect().left}px`);
    }
    summary.setAttribute('aria-expanded', String(opening));
    panel.inert = !opening;
    const finish = () => { detail.open = opening; panel.inert = false; transitions.delete(detail); };
    if (motion.matches || !panel.animate) { finish(); return; }
    const animation = panel.animate([start, { opacity: opening ? 1 : 0, transform: opening ? 'translateY(0)' : 'translateY(-5px)' }], { duration: opening ? 230 : 150, easing: 'cubic-bezier(.2,.75,.25,1)', fill: 'both' });
    const state = { animation, opening };
    transitions.set(detail, state);
    animation.onfinish = () => { if (transitions.get(detail) !== state) return; finish(); animation.cancel(); };
  };
  const initialize = (root = document) => {
    root.querySelectorAll('.hx-nav-panel--products').forEach(panel => {
      if (panel.dataset.previewReady) return;
      panel.dataset.previewReady = 'true';
      const preview = panel.querySelector('[data-hx-menu-preview]');
      if (!preview) return;
      const frames = [...preview.querySelectorAll('[data-hx-menu-frame]')];
      const warm = () => {
        if (!desktop.matches || panel.dataset.warmed) return;
        panel.dataset.warmed = 'true';
        panel.querySelectorAll('[data-hx-preview-image]').forEach(link => { const image = new Image(); image.decoding = 'async'; image.src = link.dataset.hxPreviewImage.trim(); });
      };
      const disclosure = panel.closest('details');
      disclosure?.addEventListener('toggle', () => { if (disclosure.open) warm(); });
      disclosure?.querySelector('summary')?.addEventListener('pointerenter', warm, {once:true});
      let revision = 0;
      let active = 0;
      const links = [...panel.querySelectorAll('[data-hx-preview-image]')];
      panel.style.setProperty('--hx-menu-product-count', String(links.length));
      const highlight = link => {
        const index = links.indexOf(link);
        links.forEach((item, position) => {
          const distance = Math.abs(position - index);
          item.classList.toggle('is-preview-active', item === link);
          item.style.setProperty('--hx-key-shift', `${distance === 0 ? 10 : distance === 1 ? 5 : distance === 2 ? 2 : 0}px`);
        });
      };
      const show = link => {
        const current = ++revision;
        if (!desktop.matches) return;
        highlight(link);
        preview.href = link.href;
        preview.querySelector('[data-hx-menu-title]').textContent = link.dataset.hxPreviewTitle;
        const source = link.dataset.hxPreviewImage.trim();
        if (frames[active].getAttribute('src') === source) return;
        const candidate = new Image();
        candidate.onload = () => {
          if (current !== revision) return;
          const next = active === 0 ? 1 : 0;
          const incoming = frames[next];
          incoming.src = candidate.src;
          incoming.alt = link.dataset.hxPreviewTitle;
          incoming.removeAttribute('aria-hidden');
          frames[active].alt = '';
          frames[active].setAttribute('aria-hidden', 'true');
          incoming.classList.add('is-active');
          frames[active].classList.remove('is-active');
          active = next;
          preview.href = link.href;
          preview.querySelector('[data-hx-menu-title]').textContent = link.dataset.hxPreviewTitle;
        };
        candidate.src = link.dataset.hxPreviewImage.trim();
      };
      links.forEach(link => {
        link.addEventListener('pointerenter', () => show(link));
        link.addEventListener('focus', () => show(link));
      });
      if (links.length) highlight(links[0]);

    });
    root.querySelectorAll('[data-hx-disclosure]').forEach((detail) => {
      const { summary } = parts(detail);
      summary?.setAttribute('aria-expanded', String(detail.open));
    });
  };
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-hx-disclosure] > summary');
    const detail = summary?.parentElement;
    if (detail) { event.preventDefault(); const current = transitions.get(detail); setOpen(detail, current ? !current.opening : !detail.open); }
    document.querySelectorAll('[data-hx-disclosure][open]').forEach((other) => {
      if (other !== detail && !other.contains(event.target)) setOpen(other, false);
    });
    if (event.target.closest('[data-v3-cart-open]')) {
      document.querySelectorAll('[data-hx-disclosure][open]').forEach((other) => setOpen(other, false));
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const target = event.target.closest('[data-hx-disclosure][open]');
    if (target) { event.preventDefault(); setOpen(target, false); parts(target).summary?.focus(); return; }
    document.querySelectorAll('[data-hx-disclosure][open]').forEach((detail) => setOpen(detail, false));
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-hx-disclosure][open]').forEach((detail) => {
      if (!detail.contains(event.target)) setOpen(detail, false);
    });
  });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-hx-disclosure][open]').forEach((detail) => setOpen(detail, false));
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize();
})();
